import { Card, CardContent, CardDescription, CardHeader, CardTitle, Skeleton } from '@bliks-io/ui';

interface SummaryCardProps {
  label: string;
  value: string;
  context: string;
  isLoading: boolean;
}

export function SummaryCard({ label, value, context, isLoading }: SummaryCardProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardDescription>{label}</CardDescription>
        <CardTitle className="text-3xl tabular-nums">
          {isLoading ? <Skeleton className="h-9 w-24" /> : value}
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0 text-sm text-muted-foreground">
        {isLoading ? <Skeleton className="h-4 w-32" /> : context}
      </CardContent>
    </Card>
  );
}
